import { useRef, useState } from "react";
import { MensajeError } from "../FuncionesLocales";
import { exportReport, FORMATOS_EXPORTACION } from "../../servicios/reportesExportacion";
import { ejecutarSinDuplicados } from "./exportarReporteUtils";
import { PERMISOS, puedeAcceder } from "../../servicios/sesionSeguridad";
import "./exportarReporte.css";

const ETIQUETAS = { pdf: "PDF", xlsx: "Excel", csv: "CSV" };

const ExportarReporte = ({ endpoint, filters, nombre, ranking = false, disabled = false, onExport = exportReport }) => {
  const puedeExportar = puedeAcceder(PERMISOS.REPORTES_EXPORTAR);
  const [formato, setFormato] = useState("pdf");
  const [generando, setGenerando] = useState("");
  const bloqueo = useRef(false);

  const exportar = () => ejecutarSinDuplicados(bloqueo, async () => {
    setGenerando(formato);
    try {
      await onExport({ endpoint, format: formato, filters, ranking });
    } catch (error) {
      await MensajeError(error?.message || "No se pudo generar el archivo solicitado.");
    } finally {
      setGenerando("");
    }
  });

  if (!puedeExportar) return null;

  return (
    <div className="exportar-reporte" aria-label={`Exportar ${nombre}`}>
      <label>
        <span className="exportar-reporte-solo-lectores">Formato para {nombre}</span>
        <select value={formato} disabled={disabled || Boolean(generando)} onChange={(event) => setFormato(event.target.value)}>
          {FORMATOS_EXPORTACION.map((valor) => <option key={valor} value={valor}>{ETIQUETAS[valor]}</option>)}
        </select>
      </label>
      <button type="button" disabled={disabled || Boolean(generando)} onClick={exportar}>
        {generando ? `Generando ${ETIQUETAS[generando]}…` : "Exportar"}
      </button>
    </div>
  );
};

export default ExportarReporte;
